import type { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { lineLegacyDefaultV0Schema } from './default';

export type LegacyLine = z.infer<typeof lineLegacyDefaultV0Schema>;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single placement, like accordion/indent/logo — no envelope union.
 */
export const LegacyLineEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: lineLegacyDefaultV0Schema }]);
